<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container v-if="show_lista">
        <h1 class="titulo">Rastreio de ações do contrato</h1>
        <v-row class="text-center mb-6 mt-3">
            <v-col>
                <h3>{{ formatDate(datas.data_min) }} a {{ formatDate(datas.data_max) }} - Nº Proposta: {{ proposta.id_documento }}</h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="3">
                Nome do cliente: {{ proposta.nome_completo }}
            </v-col>
            <v-col cols="3">
                CPF/CNPJ cliente: {{ proposta.cpf }}
            </v-col>
            <v-col cols="4">
                E-mail do cliente: {{ proposta.email }}
            </v-col>
            <v-col cols="2">
                Plano de venda: {{ proposta.cd_plano_venda }}
            </v-col>
        </v-row>
        <v-row class="mt-3">
            <v-col cols="3">
                Grupo: {{ proposta.cd_grupo }}
            </v-col>
            <v-col cols="3">
                Status da venda: {{ proposta.status_pedido }}
            </v-col>
            <v-col cols="4">
                Status do contrato: {{ proposta.status }}
            </v-col>
            <v-col cols="2">
                Ponto de venda: {{ proposta.id_ponto_venda }}
            </v-col>
        </v-row>
        <v-row class="mt-3 mb-4">
            <v-col cols="3">
                Empresa: {{ proposta.nm_empresa }}
            </v-col>
            <v-col cols="4">
                Bem: {{ proposta.nome_bem }}
            </v-col>
        </v-row>
        <DataTable
                :headers="headers"
                :params="params"
                url="/painel/contrato/log_contrato"
                :filter="filters"
                item-key="id">
            <template v-slot:items="{item}">
                <td>{{ item.nome }}</td>
                <td>{{ item.funcionalidade }}</td>
                <td>{{ item.data_hora | toDateTimeBR }}</td>
                <td>{{ item.operacao }}</td>
            </template>
        </DataTable>
        <v-row class="botoes-acao justify-end">
            <v-col cols="2" style="margin-top: 24px;">
                <v-btn block x-small color="primary" class="py-4" @click="exportarExcel">Download da listagem</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  import { notification } from '@/plugins/helpers'
  import * as Qs from 'qs'

  export default {
    name: 'Rastreio',
    props: { filter: Object },
    data: () => ({
      proposta: [],
      log_contrato: [],
      show_lista: false,
      datas: [],
      filters: {
        id_pedido: 0,
        acao_rastreio: ''
      }
    }),
    computed: {
      headers: () => ([
        { text: 'Nome do usuário', value: 'nome' },
        { text: 'Ação do usuário', value: 'funcionalidade' },
        { text: 'Data/hora da ação', value: 'data_hora' },
        { text: 'Log de ação', value: 'operacao' }
      ]),
      params () {
        return {
          pagination: {
            rowsPerPage: 15,
            items_grid: 15,
            sortBy: 'tb_log_contrato.data_hora',
            descending: true
          },
          custom_filter: this.customFilter
        }
      }
    },
    watch: {
      filter (val) {
        if (val.id_documento) {
          this.getProposta()
        } else {
          this.show_lista = false
        }
      }
    },
    mounted () {
    },
    methods: {
      async getProposta () {
        this.$http.get('/painel/contrato/rastreio_acao', {
          params: {
            ...this.filter
          }
        })
          .then(result => {
            this.proposta = result.data['proposta']
            this.datas = result.data['datas']
            if (this.show_lista) {
              this.filters = { ...this.filters }
            }
            this.filters.id_pedido = this.proposta.id_pedido
            this.filters.acao_rastreio = this.filter.acao_rastreio
            this.show_lista = true
          })
          .catch(err => notification('error', err, 'Não foi possível buscar o contrato!'))
      },
      exportarExcel () {
        const encoded_params = Qs.stringify({
          filter: {
            ...this.filters,
            id_documento: this.proposta.id_documento
          },
          headers: this.headers.map(header => header.value.replace('tb_log_contrato.', '').replace('tb_usuario.', ''))
        }, {
          arrayFormat: 'brackets',
          encode: true
        })
        window.open(`${this.ws}/log_contrato/exportar?${encoded_params}`)
      },
      formatDate (item) {
        if (item != null) {
          let ano = item.substring(0, 4)
          let mes = item.substring(5, 7)
          let dia = item.substring(8, 10)

          return dia + '/' + mes + '/' + ano
        } else {
          return '-'
        }
      }
    }

  }
</script>

<style scoped>
.botoes-acao .v-btn {
    flex: 1;
}
</style>
